import React, { useContext, useEffect, useRef } from 'react';
import cn from 'classnames';
import FundLaterFundContents from '../../AllocationTable/v2/FundLaterFundContents';
import { handleStickyHeader } from '../util';
import { CartContext } from '../../../context/CartContext/CartContext';
import AllocationHeader from '../../AllocationHeader/AllocationHeader';
import styles from './style.css';
import { mapFundLaterFundData } from '../../../hooks/useCartDetailsState';

export default ({
  filterOpen,
  headerOpen,
  toggleHeader,
  rewardsAvailable = { closedFunds: false, iClassFunds: false },
  amount
}) => {
  const wrapperRef = useRef(null);
  const cartState = useContext(CartContext);

  useEffect(() => {
    const scrollHandler = handleStickyHeader(wrapperRef);

    window.addEventListener('scroll', scrollHandler, {
      capture: true,
      passive: true
    });

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (filterOpen) toggleHeader(false);
  }, [filterOpen]);

  const { selectedFunds, data = {} } = cartState;

  const { mutualFunds = [] } = data;
  const selectedFundsWithData = mapFundLaterFundData(
    selectedFunds,
    mutualFunds
  );
  const noSelectedFunds = Boolean(!selectedFunds.length);

  return (
    <div className="allocation-section" ref={wrapperRef}>
      <div className="allocation-header">
        <AllocationHeader
          headerOpen={headerOpen}
          toggleHeader={toggleHeader}
          disabled={noSelectedFunds}
          fundsWithCategories={selectedFundsWithData}
          shoppingCartEmpty={noSelectedFunds}
        />
      </div>
      {headerOpen && (
        <div className={cn({ block: noSelectedFunds }, 'fund-section-wrapper')}>
          {noSelectedFunds ? (
            <div role="alert" aria-atomic="true" className="no-funds-error">
              You must select at least one mutual fund to open your account,
              additional mutual funds may be added later.
            </div>
          ) : (
            <FundLaterFundContents
              fundsWithCategories={selectedFundsWithData}
              shoppingCartEmpty={noSelectedFunds}
              rewardsAvailable={rewardsAvailable}
              amount={amount}
            />
          )}
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};
